import { formatThoughtForSecondsLabel } from '@/services/chatApi'
import { buildGeneratedArtifactAssistantBlocks } from './generatedArtifactAssistantPayloadBlocks.js'
import { resolveGeneratedArtifactDetails } from './generatedArtifactAssistantPayloadResolve.js'

export function buildGeneratedArtifactAssistantMessagePatch(trimmed, thinkingStartedAtMs) {
  const details = resolveGeneratedArtifactDetails(trimmed)
  if (!details) return null
  const { blocks, artifact } = buildGeneratedArtifactAssistantBlocks(details)
  const endedAt = Date.now()
  return {
    artifact,
    messagePatch: {
      text: '',
      blocks,
      agentBrand: 'SIA',
      agentName: 'Master Root Agent',
      thoughtSummary: formatThoughtForSecondsLabel(thinkingStartedAtMs, endedAt),
      createdAt: endedAt,
    },
  }
}
